export default __webpack_public_path__ + "static/about-block-2-d1d49f0f07b06c70b2218e02af4126ba.jpg";